// extracted by mini-css-extract-plugin
module.exports = {"body":"loadingPage_body__1ok3S","cs-loader":"loadingPage_cs-loader__3F_fB","cs-loader-inner":"loadingPage_cs-loader-inner__1t-6u","lol":"loadingPage_lol__1-aPK"};